// Material Components
import { Box, Tooltip } from "@mui/material";

// Material Common Components
import pxToRem from "assets/theme/functions/pxToRem";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";

// Utils
import Constants, { Colors, Icons } from "utils/Constants";

// 3rd party
import PropTypes from "prop-types";

const statusDimensions = {
  [Constants.ONBOARDING_PENDING]: {
    bgColor: Colors.LIGHT_GRAY5,
    color: Colors.DARK_GREY,
  },
  [Constants.ONBOARDING_IN_PROGRESS]: {
    bgColor: Colors.LIGHT_INFO_BLUE,
    color: Colors.DARK_INFO_BLUE,
  },
  [Constants.ONBOARDING_APPROVED]: {
    bgColor: Colors.LIGHT_GREEN,
    color: Colors.DARK_GREEN,
  },
  [Constants.ONBOARDING_REJECTED]: {
    bgColor: Colors.LIGHT_RED,
    color: Colors.DARK_RED,
  },
  [Constants.ONBOARDING_PENDING_SYSTEM_ISSUE]: {
    bgColor: Colors.LIGHT_GRAY5,
    color: Colors.BLACK,
  },
};

export default function OnboardingStatus({ title }) {
  const { bgColor, color } = statusDimensions[title] || {};

  let icon;
  switch (title) {
    case Constants.ONBOARDING_APPROVED:
      icon = Icons.ACCEPT;
      break;
    case Constants.ONBOARDING_REJECTED:
      icon = Icons.CROSS3;
      break;
    default:
      icon = (
        <Box
          component="span"
          backgroundColor={color}
          sx={{
            borderRadius: "50%",
            width: pxToRem(10),
            height: pxToRem(10),
          }}
        />
      );
      break;
  }

  return (
    <Tooltip title={title}>
      <MDBox
        bgColor={bgColor}
        color={color}
        variant="contained"
        borderRadius={pxToRem(16)}
        opacity={1}
        p={1}
        maxWidth="100%"
        height={pxToRem(24)}
        display="inline-flex"
        alignItems="center"
        justifyContent="flex-start"
        overflow="hidden"
      >
        <Box
          sx={{
            width: pxToRem(10),
            height: pxToRem(10),
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexShrink: 0,
          }}
        >
          {icon}
        </Box>
        <MDTypography
          ml={1}
          variant="caption"
          sx={{
            textTransform: "capitalize",
            color,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            minWidth: 0,
          }}
        >
          {title}
        </MDTypography>
      </MDBox>
    </Tooltip>
  );
}

OnboardingStatus.propTypes = {
  title: PropTypes.string.isRequired,
};
